// Main Scripts
// ---------------------
import mainSlideshow from './js/widgets/mainSlideshow.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import seoWidget from './js/widgets/seoWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import scrollerSponsors from './js/widgets/scrollerSponsors.js';
import affiliateLogo from './js/widgets/affiliateLogo.js';

// Secondary Scripts
// ---------------------
import './js/localjs.js';

$(document).ready(function () {
  if (window.location.pathname === '/') {
    mainSlideshow();
    multiScheduleFeature();
    seoWidget();
    cardsWidget();
    scrollerSponsors();
  }
  affiliateLogo();
});
